
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Capture precious family moments with a beautiful photoshoot in Goa. From stunning beaches to vibrant streets, create lasting memories with your loved ones.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the best spots in Goa for a family photoshoot. From scenic landscapes to colorful streets, capture unforgettable moments with your loved ones.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Celebrate your family’s special moments with a beautiful photoshoot in Goa. Capture lasting memories in Goa’s stunning locations!',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'family photoshoot in goa, family photoshoot, family photoshoot ideas, outdoor family photoshoot ideas, newborn family photoshoot, parra goa photography, best places for photography in goa, drone photography in goa',
        },
      
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

     
      title: 'Family Photoshoot in Goa - Family Photoshoot Ideas and Poses',
    };
  },


  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/family-photoshoot-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/family-photoshoot-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/family-photoshoot-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Family PhotoShoot in Goa - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the Family Photoshoot in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/family-photoshoot-goa",
        "url": "https://www.goa.app/family-photoshoot-goa",
        "name": "Family Photo Shoot in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-01-02T11%3A45%3A19.896Z5-%288%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZIUXu81n64jZ3lnQ1RlUG7uf%2BNwo5AwnYFQAnDhAjraAhOd3JlRtKWBQyS5dCWbVu7dNCGDvpl6GypJQ7wadpEHDTjOpRaTI8aXbY6wtwTPWOzczJjKX821OxDxTI84Y1TLjUHZmdpdqja7cBFybYU9HxjPQICbgmdFJ%2FRYdukZDVbbDUIBrgKqn04NlgyKOl7%2BHyT4V0Y8zZdAqQKBx%2FcURakAy0slJ9YqrTfSSMGw0zAMH%2FXuwPdyA9PV%2Bq7CC7qaWSWo4xHsk28I87In3rkyISGndn2Tmr5jpyXJKIckHyIa2yY5JiZwtUhVWRq8X43q98kLvkIi34OVlM2%2FZ1g%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Family Photo Shoot in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/family-photoshoot-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/family-photoshoot-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the best locations for a family photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some of the best locations for family photoshoots in Goa include Candolim Beach, Chapora Fort, Vagator Beach, and the lush landscapes of Dudhsagar Falls."
    }
  },
  {
    "@type": "Question",
    "name": "What types of family photoshoot packages are available in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "In Goa, you can find various family photoshoot packages, including beach sessions, outdoor adventures, and themed shoots tailored to families."
    }
  },
  {
    "@type": "Question",
    "name": "How much does a family photoshoot cost in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Family photoshoot sessions in Goa typically start from ₹4,999, depending on the location and package you choose."
    }
  },
  {
    "@type": "Question",
    "name": "Can I book a photographer for a family event in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many photographers in Goa offer customizable packages for family events such as reunions, birthdays, and celebrations."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for a family photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for family photoshoots in Goa is during the golden hours, shortly after sunrise and before sunset, to achieve beautiful lighting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any restrictions on family photoshoots at certain locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, some locations in Goa may have restrictions on photography, especially private properties or during specific events. Always check beforehand."
    }
  },
  {
    "@type": "Question",
    "name": "Do family photoshoot packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most family photoshoot packages in Goa include basic editing services, but you can request additional retouching for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose the location for my family photoshoot?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Many photographers will work with you to select locations that reflect your family's personality and vision."
    }
  },
  {
    "@type": "Question",
    "name": "What should my family wear for a photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "It is recommended to choose comfortable and vibrant outfits that complement the scenery. Light fabrics and bright colors work well in Goa's sunny climate."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a family photoshoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a family photoshoot in Goa through various platforms, including the Goa App, where you can find reputable photographers and package details."
    }
  }


        ]
      }
    ]
  };
},


};



  